import { useMemo } from 'react';
/** Sorts additionalMedia by position, memoizes, and always returns an array */ export function useAdditionalMedia(deviation) {
    var _deviation_extended;
    return useMemo(()=>{
        var _deviation_extended;
        const additionalMedia = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.additionalMedia;
        if (!additionalMedia) {
            return [];
        }
        const sorted = additionalMedia.sort((a, b)=>{
            var _a_position, _b_position;
            return ((_a_position = a.position) !== null && _a_position !== void 0 ? _a_position : 0) - ((_b_position = b.position) !== null && _b_position !== void 0 ? _b_position : 0);
        });
        return sorted;
    }, [
        (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.additionalMedia
    ]);
}

//# sourceMappingURL=useAdditionalMedia.js.map